import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import { conf, t } from '../../domain/services/configService';
import { SmartLink } from '../SmartLink';
import { Image } from '../Image';
import { apiClientService } from '../../domain/services/apiClientService';
import { theme } from '../../domain/theme';

export const SubscriptionBlock = ({ id }) => {
  const [data, setData] = useState();

  useEffect(() => {
    const fetchData = async () => {
      const url = `/ajax/subscription_block/${id}.json`;
      const { response } = await apiClientService.getJson(url);
      setData(response?.data?.content);
    };
    fetchData();
  }, []);
  const subscribeBlockLink =
    data?.subscriptionCtaLink?.url?.path ||
    conf.third_party_subscription_cta_link ||
    `/${t('SubscribeCTA')}`;
  const style = {
    wrapper: css`
      margin-bottom: 33px;
      display: inline-block;
      width: 100%;
      max-width: 300px;
      padding: 30px 30px 50px;
      background: #000;
      color: #fff;
      overflow: hidden;
    `,
    header: css`
      text-transform: uppercase;
      text-align: center;
      line-height: 1.125rem;
      margin-bottom: 45px;
      width: 100%;
      span {
        ${theme.font.family('regularWeb')};
        font-weight: 400;
        font-size: 0.75rem;
        letter-spacing: 3px;
        line-height: 1.5;
        color: #fff;
        display: inline-block;
        width: 100%;
        &.subscribe {
          ${theme.font.family('boldWeb')};
          font-style: normal;
        }
      }
    `
  };
  return (
    <div css={style.wrapper}>
      {data && (
        <SmartLink to={subscribeBlockLink}>
          <div css={style.header}>
            <span className="subscribe">
              {data.cardHeader || t('Subscribe')}
            </span>
            {data.cardSubheader ? <span>{data.cardSubheader}</span> : null}
          </div>
          {data.backgroundImage?.entity?.mediaImage?.url && (
            <Image
              entity={data.backgroundImage.entity}
              maxWidths={{
                mobile: 240,
                tablet: 240,
                small_desktop: 240,
                large_desktop: 240
              }}
            />
          )}
        </SmartLink>
      )}
    </div>
  );
};
SubscriptionBlock.propTypes = {
  id: PropTypes.string.isRequired
};
